<template>
  <div class="c-filter">
    <ElForm label-width="62px" inline class="elementui-common-form-styles" v-highlight>
      <div>
        <ElFormItem label="计划">
          <el-input class="plan-input" style="width: 150px" @focus="isShowDialog('计划选择', '计划')">
            <i class="el-icon-arrow-down" slot="suffix"> </i>
            <template slot="prepend">
              <div class="prepend" @click.stop="isShowDialog('计划选择', '计划')">
                <el-tag type="info" class="cursor-pointer" v-if="planTags && planTags.length">
                  <span :title="planTags.map((i) => i.name).join(', ')">{{ planTags[0].name }}</span>
                </el-tag>
                <em v-if="planTags.length > 1">+ {{ planTags.length - 1 }}</em>
              </div>
            </template>
          </el-input>
        </ElFormItem>
        <ElFormItem label="素材">
          <el-input class="plan-input" style="width: 150px" @focus="isShowDialog('素材选择', '素材')">
            <i class="el-icon-arrow-down" slot="suffix"> </i>
            <template slot="prepend">
              <div class="prepend" @click.stop="isShowDialog('素材选择', '素材')">
                <el-tag type="info" class="cursor-pointer" v-if="imageTags && imageTags.length">
                  <span :title="imageTags.map((i) => i.name).join(', ')">{{ imageTags[0].name }}</span>
                </el-tag>
                <em v-if="imageTags.length > 1">+ {{ imageTags.length - 1 }}</em>
              </div>
            </template>
          </el-input>
        </ElFormItem>
        <ElFormItem label="平台">
          <el-select v-model="platforms" multiple collapse-tags filterable clearable style="width: 120px" placeholder="请选择">
            <el-option v-for="item in platformsData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="应用组">
          <el-select v-model="gameGroupIds" style="width: 180px" multiple collapse-tags filterable clearable placeholder="请选择">
            <el-option v-for="(item, index) in GAME_GROUPS" :key="index" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="应用" label-width="38px">
          <el-select v-model="gameIds" style="width: 180px" multiple collapse-tags filterable clearable placeholder="请选择">
            <el-option v-for="(item, index) in GAMES" :key="index" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="项目组">
          <el-select v-model="initProjectGroupIds" style="width: 180px" multiple collapse-tags filterable clearable placeholder="请选择">
            <el-option v-for="(item, index) in PROJECT_GROUP" :key="index" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="人员" label-width="38px">
          <ThrottleSelector
            v-model="opIds"
            :list="PTOM_USERS"
            style="width: 180px"
            placeholder="请选择"
            multiple
            collapse-tags
            filterable
            clearable
          />
        </ElFormItem>

        <ElFormItem label="媒体" label-width="38px">
          <el-select v-model="mediaIds" multiple collapse-tags filterable clearable placeholder="请选择" @change="handleMedia">
            <el-option v-for="item in MEDIAS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem v-if="complexRoute && subMediaOptions.length" label="媒体版本">
          <el-select v-model="subMediaIds" multiple collapse-tags clearable style="width: 180px" placeholder="请选择">
            <el-option
              v-for="item in subMediaOptions"
              :key="item.mediaId + '-' + item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="投放版位">
          <el-select v-model="advPositionIds" multiple collapse-tags filterable clearable style="width: 170px" placeholder="请选择">
            <el-option v-for="item in advertPositionData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="账号" label-width="38px">
          <ThrottleSelector
            v-model="adAccountIdList"
            :list="MEDIA_ACCOUNTS"
            style="width: 180px"
            placeholder="请选择"
            multiple
            collapse-tags
            filterable
            clearable
          />
        </ElFormItem>
        <ElFormItem label="优化目标">
          <el-select v-model="optimizationTypes" multiple collapse-tags filterable clearable placeholder="请选择">
            <el-option v-for="item in optimizationData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="深度优化目标" label-width="90px">
          <el-select v-model="deepOptimizationTypes" multiple collapse-tags filterable clearable placeholder="请选择">
            <el-option v-for="item in deepOptimizationData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <template v-if="complexRoute">
          <ElFormItem label="投放模式">
            <el-select v-model="launchModes" multiple collapse-tags filterable clearable placeholder="请选择">
              <el-option v-for="item in launchModesData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </ElFormItem>
          <ElFormItem label="竞价策略">
            <el-select v-model="biddingStrategys" multiple collapse-tags filterable clearable placeholder="请选择">
              <el-option v-for="item in biddingStrategysData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </ElFormItem>
          <ElFormItem label="原生计划">
            <el-select v-model="nativeAdverts" multiple collapse-tags filterable clearable placeholder="请选择">
              <el-option v-for="item in nativeAdvertsData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </ElFormItem>
          <ElFormItem label="抖音号" label-width="50px">
            <el-select v-model="douyinNos" multiple collapse-tags filterable clearable placeholder="请选择">
              <el-option v-for="item in douyinList" :key="item.accountId" :label="item.accountName" :value="item.accountId"> </el-option>
            </el-select>
          </ElFormItem>
          <ElFormItem label="视频号" label-width="50px">
            <el-select v-model="shipinNos" multiple collapse-tags filterable clearable placeholder="请选择">
              <el-option v-for="item in weixinList" :key="item.accountId" :label="item.accountName" :value="item.accountId"> </el-option>
            </el-select>
          </ElFormItem>
          <ElFormItem label="快手号" label-width="50px">
            <el-select v-model="kuanshouNos" multiple collapse-tags filterable clearable placeholder="请选择">
              <el-option v-for="item in kuaishouList" :key="item.accountId" :label="item.accountName" :value="item.accountId"> </el-option>
            </el-select>
          </ElFormItem>

          <ElFormItem label="代投账号">
            <el-select v-model="proxyAccountIds" multiple collapse-tags filterable clearable placeholder="全部">
              <el-option v-for="item in AGENTS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </ElFormItem>

          <ElFormItem label="性别" label-width="38px">
            <el-select v-model="genders" placeholder="全部" clearable>
              <el-option v-for="item in genderData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </ElFormItem>
        </template>

        <ElFormItem label="是否代投">
          <el-select v-model="proxyFlag" style="width: 160px" collapse-tags clearable>
            <el-option v-for="item in proxyStatus" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="流量来源">
          <el-select v-model="launchSource" clearable style="width: 90px" placeholder="全部">
            <el-option v-for="item in launchSourceData" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="媒体平台">
          <el-select v-model="mediaPlatform" clearable style="width: 90px" placeholder="全部">
            <el-option v-for="item in mediaPlatformData" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="投放类型">
          <el-select
            v-model="deliveryTypes"
            style="width: 180px"
            multiple
            collapse-tags
            filterable
            clearable
            placeholder="请选择投放类型"
            :loading="deliveryTypeOptionsLoading"
          >
            <el-option v-for="item in deliveryTypeOptions" :key="item.code" :label="item.name" :value="item.code"> </el-option>
          </el-select>
        </ElFormItem>

        <el-button type="primary" @click="sendEvent">查询</el-button>
        <el-button type="text" @click="clearAll('screen')">清空</el-button>
      </div>
      <dimension
        ref="dimensionRef"
        :config="{ indeterminate: false }"
        :dimensions="dimensions"
        @handleCheckAllChange="handleCheckAllChange"
        @handleCheckedDimensChange="handleCheckedDimensChange"
      ></dimension>
    </ElForm>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="62%">
      <filter-dialog
        ref="filterDialogRef"
        :title="title"
        :backPlan="backPlan"
        :backImage="backImage"
        :filtersData="{ MEDIAS, MEDIA_ACCOUNTS, PTOM_USERS, GAME_GROUPS, GAMES }"
      ></filter-dialog>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
/**
 * @description: 综合效果报表与小程序综合效果报表公用一个查询组件
 */
import { checkedData, checkedDataForComplex, checkedObj, checkedObjForComplex } from '../js/dimensionsData.js'
import {
  optimization,
  deepOptimization,
  genderData,
  mediaPlatformData,
  deliveryTypeList,
  biddingStrategysData,
  launchSourceData
} from '../js/filterData.js'
import FilterDialog from './filter-dialog'
import { getSubMediaOptionsByMediaIds } from '@/common/js/constants'
import { getComplexReportNativeAccounts } from '@/api/common.model.js'
import { getComplexReportDeliveryTypeOptions } from '@/api/report.model.js'
import { transferTaskQueryConditions } from '@/views/download-center/data/utils.js'
import {
  initPageData,
  PROJECT_GROUP,
  MEDIA_POSITION,
  MEDIA_ACCOUNTS,
  GAME_GROUPS,
  GAMES,
  MEDIAS,
  PTOM_USERS,
  AGENTS
} from '@/data/global-opts'
import Dimension from '@/components/dimension/index.vue'
import ThrottleSelector from '@/components/throttle-select/index.vue'
// DOUYIN_ACCOUNT, SHIPIN_ACCOUNT, KUAISHOU_ACCOUNT
// 当前页面需要的下拉数据项
const PAGE_REQUIRED_OPTS = initPageData([PROJECT_GROUP, MEDIA_POSITION, MEDIA_ACCOUNTS, GAME_GROUPS, GAMES, MEDIAS, PTOM_USERS, AGENTS])
const DELIVERY_TYPE_CODE_TO_MEDIA = {
  TENCENT: 16,
  BYTEDANCE: 10,
  KUAISHOU: 32
}
const defaultCheckParams = {
  dimPlan: 0,
  dimImage: 0,
  dimPlatform: 0,
  dimGameGroup: 0,
  dimGame: 0,
  dimProjectGroup: 0,
  dimOp: 0,
  dimMedia: 0,
  dimSubMedia: 0,
  dimAdvPosition: 0,
  dimAdAccount: 0,
  dimOptimizationType: 0,
  dimDeepOptimizationType: 0,
  dimProxyAccount: 0,
  dimLaunchMode: 0,
  dimLaunchSource: 0,
  dimBiddingStrategy: 0,
  dimNativeAdvert: 0,
  dimDouyinNo: 0,
  dimShipinNo: 0,
  dimKuanshouNo: 0,
  dimDeliveryType: 0
}

export default {
  name: 'detailFilter',
  components: {
    FilterDialog,
    Dimension,
    ThrottleSelector
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    advertPositionData() {
      const data = []
      if (this.mediaIds && this.mediaIds.length) {
        this.MEDIA_POSITION.filter((res) => this.mediaIds.map((item) => res.mediaId === item && data.push(res)))
      }
      return data
    },
    optimizationData() {
      return this.filterTargets(this.optimization)
    },
    deepOptimizationData() {
      return this.filterTargets(this.deepOptimization)
    },
    planTags() {
      return this.planTagLists
    },
    imageTags() {
      return this.imageTagLists
    },
    deliveryTypeOptions() {
      if (!this.mediaIds || !this.mediaIds.length) return this.deliveryTypeList

      const selectedMediaIds = this.mediaIds
      const priorityCodes = this.deliveryTypePriorityCodes
      return this.deliveryTypeList
        .map((item, index) => ({ item, index }))
        .sort((a, b) => {
          const aRank = this.getDeliveryTypeRank(a.item, selectedMediaIds, priorityCodes)
          const bRank = this.getDeliveryTypeRank(b.item, selectedMediaIds, priorityCodes)
          if (aRank !== bRank) return aRank - bRank
          return a.index - b.index
        })
        .map(({ item }) => item)
    },
    subMediaOptions() {
      return getSubMediaOptionsByMediaIds(this.mediaIds).map((item) => ({
        mediaId: item.mediaId,
        value: item.id,
        label: item.name
      }))
    }
  },
  watch: {
    mediaIds(val) {
      this.refreshDeliveryTypeOptions(val)
    }
  },
  data() {
    const complexRoute = this.$route.path.includes('/complex')
    return {
      complexRoute,
      kuaishouList: [],
      deliveryTypeList,
      deliveryTypePriorityCodes: [],
      deliveryTypeOptionsLoading: false,
      weixinList: [],
      douyinList: [],
      optimization,
      deepOptimization,
      filtersData: {},
      platforms: [],
      genderData,
      mediaPlatformData,
      platformsData: [
        { id: 1, name: '安卓' },
        { id: 2, name: 'iOS' },
        { id: 3, name: '小程序' },
        { id: 4, name: 'PC' },
        { id: 5, name: '鸿蒙' }
      ],
      launchModesData: [
        { id: 1, name: '手动投放' },
        { id: 2, name: '自动投放' }
      ],
      nativeAdvertsData: [
        { id: 0, name: '常规计划' },
        { id: 1, name: '原生计划' },
        { id: 2, name: '达人视频' }
      ],
      biddingStrategysData,
      gameGroupIds: [],
      gameIds: [],
      initProjectGroupIds: [],
      opIds: [],
      mediaIds: [],
      subMediaIds: [],
      advPositionIds: [],
      adAccountIdList: [],
      optimizationTypes: [],
      deepOptimizationTypes: [],
      launchSource: '',
      mediaPlatform: '',
      launchSourceData,
      launchModes: [],
      biddingStrategys: [],
      nativeAdverts: [],
      douyinNos: [],
      shipinNos: [],
      kuanshouNos: [],
      proxyAccountIds: [],
      genders: '',
      dimensions: complexRoute ? checkedDataForComplex : checkedData,
      checkedObj: complexRoute ? checkedObjForComplex : checkedObj,
      checkedDimens: [],
      isIndeterminate: false,
      checkAll: false,
      checkedParams: Object.assign({}, defaultCheckParams),
      title: '',
      backPlan: [],
      backImage: [],
      dialogVisible: false,
      planTagLists: [],
      imageTagLists: [],
      proxyFlag: '',
      proxyStatus: [
        { id: 1, name: '是' },
        { id: 0, name: '否' }
      ],
      deliveryTypes: []
    }
  },
  created() {
    this.getMediaNativeAccounts()
    this.refreshDeliveryTypeOptions()
  },
  methods: {
    inferDeliveryTypeMediaId(code) {
      const prefix = Object.keys(DELIVERY_TYPE_CODE_TO_MEDIA).find((key) => code && code.indexOf(key) === 0)
      return prefix ? DELIVERY_TYPE_CODE_TO_MEDIA[prefix] : undefined
    },
    normalizeDeliveryTypeOption(item) {
      const code = item.code
      return {
        code,
        name: item.name || item.desc,
        mediaId: item.mediaId || this.inferDeliveryTypeMediaId(code),
        mediaName: item.mediaName
      }
    },
    normalizeDeliveryTypeOptions(list) {
      return (Array.isArray(list) ? list : [])
        .map((item) => this.normalizeDeliveryTypeOption(item))
        .filter((item) => item.code && item.name && !['UNKNOWN', 'NONE'].includes(item.code))
    },
    mergeDeliveryTypeOptions(...groups) {
      const map = new Map()
      groups.forEach((group) => {
        const safeGroup = group || []
        safeGroup.forEach((item) => {
          if (!item || !item.code) return
          map.set(item.code, { ...(map.get(item.code) || {}), ...item })
        })
      })
      return Array.from(map.values())
    },
    getDeliveryTypeRank(item, selectedMediaIds, priorityCodes) {
      if (priorityCodes.includes(item.code)) return 0
      if (selectedMediaIds.includes(item.mediaId)) return 1
      return 2
    },
    async refreshDeliveryTypeOptions(mediaIds = this.mediaIds) {
      const selectedMediaIds = mediaIds || []
      const mediaId = selectedMediaIds.length === 1 ? selectedMediaIds[0] : undefined
      this.deliveryTypeOptionsLoading = true
      try {
        const data = await getComplexReportDeliveryTypeOptions(mediaId ? { mediaId } : undefined)
        const remoteOptions = this.normalizeDeliveryTypeOptions(data)

        if (remoteOptions.length) {
          this.deliveryTypeList = this.mergeDeliveryTypeOptions(this.normalizeDeliveryTypeOptions(deliveryTypeList), this.deliveryTypeList, remoteOptions)
          this.deliveryTypePriorityCodes = mediaId ? remoteOptions.map((item) => item.code) : []
        } else {
          this.deliveryTypeList = this.mergeDeliveryTypeOptions(this.normalizeDeliveryTypeOptions(deliveryTypeList), this.deliveryTypeList)
          this.deliveryTypePriorityCodes = []
        }
      } finally {
        this.deliveryTypeOptionsLoading = false
      }
    },
    filterTargets(filterType) {
      let data = []
      const obj = {}
      if (this.mediaIds && this.mediaIds.length) {
        filterType.filter((res) => this.mediaIds.map((item) => res.media && res.media.includes(item) && data.push(res)))
        data = data.reduce((cur, next) => {
          // eslint-disable-next-line no-unused-expressions
          obj[next.id] ? '' : (obj[next.id] = true && cur.push(next))
          return cur
        }, [])
      }
      return data
    },
    buildParams() {
      const {
        dimPlan,
        dimImage,
        dimPlatform,
        dimGameGroup,
        dimGame,
        dimProjectGroup,
        dimOp,
        dimMedia,
        dimSubMedia,
        dimAdvPosition,
        dimAdAccount,
        dimOptimizationType,
        dimDeepOptimizationType,
        dimProxyAccount,
        dimLaunchMode,
        dimLaunchSource,
        dimMediaPlatform,
        dimBiddingStrategy,
        dimNativeAdvert,
        dimDouyinNo,
        dimShipinNo,
        dimKuanshouNo,
        dimGender,
        dimAge,
        dimRetargetingTagsIncludes,
        dimRetargetingTagsExcludes,
        dimDeliveryType
      } = this.checkedParams
      const params = {
        platforms: this.platforms.length ? this.platforms : undefined,
        gameGroupIds: this.gameGroupIds.length ? this.gameGroupIds : undefined,
        gameIds: this.gameIds.length ? this.gameIds : undefined,
        initProjectGroupIds: this.initProjectGroupIds.length ? this.initProjectGroupIds : undefined,
        opIds: this.opIds.length ? this.opIds : undefined,
        mediaIds: this.mediaIds.length ? this.mediaIds : undefined,
        subMediaIds: this.complexRoute && this.subMediaOptions.length && this.subMediaIds.length ? this.subMediaIds : undefined,
        advPositionIds: this.advPositionIds.length ? this.advPositionIds : undefined,
        adAccountIdList: this.adAccountIdList.length ? this.adAccountIdList : undefined,
        optimizationTypes: this.optimizationTypes.length ? this.optimizationTypes : undefined,
        deepOptimizationTypes: this.deepOptimizationTypes.length ? this.deepOptimizationTypes : undefined,
        launchSource: this.launchSource === '' ? undefined : this.launchSource,
        mediaPlatform: this.mediaPlatform === '' ? undefined : this.mediaPlatform,
        ptomPlan: this.planTagLists.length ? this.planTagLists : undefined,
        ptomImage: this.imageTagLists.length ? this.imageTagLists : undefined,
        proxyFlag: this.proxyFlag === '' ? undefined : this.proxyFlag,
        launchModes: this.launchModes.length ? this.launchModes : undefined,
        biddingStrategys: this.biddingStrategys.length ? this.biddingStrategys : undefined,
        nativeAdverts: this.nativeAdverts.length ? this.nativeAdverts : undefined,
        douyinNos: this.douyinNos.length ? this.douyinNos : undefined,
        shipinNos: this.shipinNos.length ? this.shipinNos : undefined,
        kuanshouNos: this.kuanshouNos.length ? this.kuanshouNos : undefined,
        genders: typeof this.genders === 'number' ? [this.genders] : undefined,
        proxyAccountIds: this.proxyAccountIds.length ? this.proxyAccountIds : undefined,
        deliveryTypes: this.deliveryTypes.length ? this.deliveryTypes : undefined,
        dimPlan: dimPlan || undefined,
        dimImage: dimImage || undefined,
        dimPlatform: dimPlatform || undefined,
        dimGameGroup: dimGameGroup || undefined,
        dimGame: dimGame || undefined,
        dimProjectGroup: dimProjectGroup || undefined,
        dimOp: dimOp || undefined,
        dimMedia: dimMedia || undefined,
        dimSubMedia: this.complexRoute ? dimSubMedia || undefined : undefined,
        dimAdvPosition: dimAdvPosition || undefined,
        dimAdAccount: dimAdAccount || undefined,
        dimOptimizationType: dimOptimizationType || undefined,
        dimDeepOptimizationType: dimDeepOptimizationType || undefined,
        dimLaunchSource: dimLaunchSource || undefined,
        dimMediaPlatform: dimMediaPlatform || undefined,
        dimProxyAccount: dimProxyAccount || undefined,
        dimLaunchMode: dimLaunchMode || undefined,
        dimBiddingStrategy: dimBiddingStrategy || undefined,
        dimNativeAdvert: dimNativeAdvert || undefined,
        dimDouyinNo: dimDouyinNo || undefined,
        dimShipinNo: dimShipinNo || undefined,
        dimKuanshouNo: dimKuanshouNo || undefined,
        dimGender: dimGender || undefined,
        dimAge: dimAge || undefined,
        dimRetargetingTagsIncludes: dimRetargetingTagsIncludes || undefined,
        dimRetargetingTagsExcludes: dimRetargetingTagsExcludes || undefined,
        dimDeliveryType: dimDeliveryType || undefined
      }

      return params
    },
    /**
     * @description: 添加导出任务时转化查询条件为可读的字符串
     * @param {*} extraParams
     * @param {*} pageType
     * @return {*}
     */
    getTransferedTaskQueryConditions(extraParams, pageType) {
      return transferTaskQueryConditions.call(this, { ...this.buildParams(), ...extraParams }, pageType)
    },
    sendEvent(type) {
      const params = this.buildParams()
      if (type === 'save') this.$emit('on-save', params)
      else {
        this.$emit('on-change', params)
      }
    },
    // src\views\report\comprehension-report\realtime.vue sendSaveClick调用了方法
    saveFilter() {
      this.sendEvent('save')
    },
    handleMedia(meta) {
      // this.mediaIds = meta.id
      this.subMediaIds = []
      this.optimizationTypes = []
      this.deepOptimizationTypes = []
    },
    clearAll(type) {
      if (type === 'screen') {
        this.clearScreen()
      }
      if (type === 'dimens') {
        this.checkAll = false
        this.checkedDimens = []
        this.isIndeterminate = false
      }
    },
    clearScreen() {
      this.platforms = []
      this.gameGroupIds = []
      this.gameIds = []
      this.initProjectGroupIds = []
      this.opIds = []
      this.mediaIds = []
      this.subMediaIds = []
      this.advPositionIds = []
      this.adAccountIdList = []
      this.optimizationTypes = []
      this.deepOptimizationTypes = []
      this.launchSource = ''
      this.mediaPlatform = ''
      this.planTagLists = []
      this.imageTagLists = []
      this.launchModes = []
      this.biddingStrategys = []
      this.nativeAdverts = []
      this.douyinNos = []
      this.shipinNos = []
      this.kuanshouNos = []
      this.proxyAccountIds = []
      this.proxyFlag = ''
      this.genders = ''
      this.deliveryTypes = []
    },
    setDimensions(dims) {
      this.$refs.dimensionRef.setData(dims)
    },
    // 维度全选
    handleCheckAllChange(val) {
      const column = []
      if (val === true) {
        this.dimensions.forEach((item) => {
          column.push(item.label)
          this.checkedParams[this.checkedObj[item.label]] = 1
          this.$set(item, 'disabled', false)
        })
      } else {
        this.checkAll = false
        this.dimensions.forEach((item) => {
          this.checkedParams[this.checkedObj[item.label]] = 0
          item.disabled = item.label === '优化目标' || item.label === '深度优化目标'
        })
        this.checkedParams = Object.assign({}, defaultCheckParams)
      }
      this.checkedDimens = val ? column : []
      this.isIndeterminate = false
    },
    // 维度单个选中
    handleCheckedDimensChange(value) {
      this.checkedDimens = value
      // 媒体选择交互
      if (value.includes('媒体')) {
        this.dimensions.map((item) => {
          this.$set(item, 'disabled', false)
        })
      } else {
        if (value.includes('优化目标')) {
          this.checkedDimens.splice(
            value.findIndex((i) => i === '优化目标'),
            1
          )
        }
        if (value.includes('深度优化目标')) {
          this.checkedDimens.splice(
            value.findIndex((i) => i === '深度优化目标'),
            1
          )
        }
        this.dimensions.map((item) => {
          if (item.label === '优化目标' || item.label === '深度优化目标') {
            item.disabled = true
          }
        })
      }

      // 维度选择与table交互
      this.dimensions.map((item) => {
        this.checkedParams[this.checkedObj[item.label]] = 0
        if (value.length) {
          value.map((val) => {
            this.$set(this.checkedParams, this.checkedObj[val], val && 1)
          })
        }
      })
      const checkedCount = value.length
      this.checkAll = checkedCount === this.dimensions.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.dimensions.length
    },
    isShowDialog(type, msg) {
      this.title = type
      this.$nextTick(() => {
        this.$refs.filterDialogRef.plan = {
          mediaIds: [],
          adAccountIdList: [],
          opId: [],
          planName: ''
        }
        this.$refs.filterDialogRef.image = {
          gameGroupIds: [],
          gameIds: [],
          opIds: [],
          imageName: ''
        }
        this.$refs.filterDialogRef.getData()
      })
      this.dialogVisible = true
      this.backPlan = this.planTagLists
      this.backImage = this.imageTagLists
    },
    submit() {
      this.dialogVisible = false
      if (this.title === '计划选择') {
        this.planTagLists = this.$refs.filterDialogRef.getSelectData()
      } else {
        this.imageTagLists = this.$refs.filterDialogRef.getSelectData()
      }
    },
    async getMediaNativeAccounts() {
      try {
        this.douyinList = await getComplexReportNativeAccounts({ accountType: 1 })
        this.weixinList = await getComplexReportNativeAccounts({ accountType: 2 })
        this.kuaishouList = await getComplexReportNativeAccounts({ accountType: 3 })
      } catch (e) {
        console.log('eeeeee output: ', e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title,
.clear {
  line-height: 32px;
  font-size: 12px;
}
.el-checkbox-group {
  display: inline-block;
}
.c-filter {
  ::v-deep .el-checkbox__label {
    font-size: 12px;
  }
}

.plan-input {
  position: relative;
  cursor: pointer;
  .el-icon-arrow-down {
    position: absolute;
    top: 50%;
    right: 0px;
    transform: translateY(-50%);
  }
}
::v-deep .el-input-group__prepend {
  position: absolute;
  padding: 0;
  width: 100%;
  height: 100%;
  background: none;
  border: none;
  .prepend {
    display: flex;
    align-items: center;
    height: 100%;

    .cursor-pointer {
      > span {
        width: 100%;
        display: inline-block;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    em {
      display: inline-block;
      margin-left: 2px;
      padding: 0 5px;
      line-height: 22px;
      background: #f5f5f5;
      border: 1px solid #e9e9eb;
      border-radius: 4px;
    }
  }
}
::v-deep .el-select .el-tag__close.el-icon-close {
  right: -3px;
  top: 1px;
}
.dimens {
  display: inline-block;
  margin-left: 10px;
  .el-checkbox {
    margin-right: 10px;
  }
}
</style>
